import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useSetRecoilState, useRecoilValue } from 'recoil';

import {
  API_QUERY_KEYS,
  getManageConsultees,
  GetManageConsulteesResponse,
  QueryDefaults,
} from 'api';
import { manageConsulteePageNumberState, manageConsulteesRequestState } from 'store';

export const useManageConsultees = (
  organisationName?: string
): UseQueryResult<GetManageConsulteesResponse> => {
  let request = useRecoilValue(manageConsulteesRequestState);
  const setPageNumber = useSetRecoilState(manageConsulteePageNumberState);

  if (organisationName) request = { ...request, organisationName };

  return useQuery(
    [API_QUERY_KEYS.getManageConsultees, request],
    () => getManageConsultees(request),
    {
      ...QueryDefaults,
      onSuccess: (data: GetManageConsulteesResponse) => {
        if (data?.paginationInfo?.totalCount > 0 && data?.consultees.items.length === 0) {
          setPageNumber(1);
        }
      },
    }
  );
};
